import { useMutation, useQueryClient } from "@tanstack/react-query";

import { supabase } from "@/shared/lib/supabase";
import { queryKeys } from "@/shared/utils/queryKeys";

export function useMarkNotificationsRead(estateId: number | undefined) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      if (!estateId) return;
      const { error } = await supabase.functions.invoke("communications/notifications/mark-read", {
        body: { estate_id: estateId, all: true },
        method: "POST",
      });
      if (error) throw new Error(error.message);
    },
    onSuccess: () => {
      if (estateId) {
        queryClient.invalidateQueries({
          queryKey: queryKeys.user.notifications(estateId),
        });
      }
    },
  });
}
